import React from 'react'
import { useTranslation } from 'react-i18next'

const DonutChart = ({ width = 56, height = 56, percentage = 69, ringColor = '#FF747F', centralColor = '#5E639B', textColor = '#ffffff', fontSize = 12, loading = false }) => {
    const { t } = useTranslation()
    const radius = 25
    const strokeWidth = 6
    const circleCircumference = 2 * Math.PI * radius
    const strokeDashoffset = circleCircumference - (circleCircumference * percentage) / 100

    return (
        <div className="flex items-center justify-center relative">
            <svg width={width} height={height} viewBox="0 0 56 56" className="rotate-[-90deg]">
                <circle cx="28" cy="28" r={radius} fill="transparent" stroke="transparent" strokeWidth={strokeWidth} />
                <circle
                    cx="28"
                    cy="28"
                    r={radius}
                    fill="transparent"
                    stroke={ringColor}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circleCircumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    className="em-donut-ring"
                />
                <circle cx="28" cy="28" r={radius - strokeWidth} fill={centralColor} />
            </svg>
            {loading ? (
                <div className="absolute">{t('Loading')}...</div>
            ) : (
                <span className="absolute font-medium" style={{ color: textColor, fontSize: fontSize }}>
                    {percentage}%
                </span>
            )}
        </div>
    )
}

export default DonutChart
